<template>
	<div class="page f fy">

		<Header></Header>



		<div class="f-1 relative f fx p-1">
			<div class="relative f fy" style="width:150px;">
				<div class="f-1 relative">
					<el-card>
						<div class="relative cmt-1">


							<!-- <div
						:class="'relative oh br px-1 py-0-5 hm f fx fcc '+($route.path=='/llm_manage'?'bg-primary text-white':'')"
						@click="goTo('/llm_manage')">
						LLM 管理
					</div> -->


							<div :class="'relative oh br px-1 py-0-5 hm f fx fcc '+($route.path=='/role_manage'?'bg-primary text-white':'')"
								@click="goTo('/role_manage')">
								角色管理
							</div>


							<div :class="'relative oh br px-1 py-0-5 hm f fx fcc '+($route.path=='/robot_manage'?'bg-primary text-white':'')"
								@click="goTo('/robot_manage')">
								设备管理
							</div>


							<div :class="'relative oh br px-1 py-0-5 hm f fx fcc '+($route.path=='/chat_for_params'?'bg-primary text-white':'')"
								@click="openChatForParams">
								提示词测试
							</div>



						</div>

					</el-card>
				</div>


				<div class="relative f fx fcc cml-1 mb-1">
					<div class="relative f-1">
						{{userInfo.username}}
					</div>

					<el-button size="mini" @click="setLogout();goTo('/')">logout</el-button>
				</div>
				<el-tag v-if="isSystemAdmin" size="mini">system administrator</el-tag>
				<el-tag v-if="isStationAdmin" size="mini">station administrator</el-tag>
				<Upload @success="onUploadSuccess">
					<el-button class="relative block mt-1" size="mini" type="success">Upload Image</el-button>
				</Upload>
			</div>
			<div class="f-1 relative ml-1 oya">
				<slot></slot>
			</div>
		</div>


	</div>
</template>

<script>
	import Upload from '@/components/Upload'
	import Header from './Header.vue';
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			Header,
			Upload,
		},
		data() {
			return {

			}
		},
		mounted() {

			request({
				url: '/api/role/selectRolePage',
				data: {}
			})

		},
		methods: {
			onUploadSuccess(resp) {

				this.$alert(JSON.stringify(resp), '', {
					callback: () => {

					}
				});
			},
			openChatForParams(){
				window.open('#/chat_for_params')
			}
		}
	}
</script>

<style>




</style>